module.exports = __webpack_public_path__ + "img/9788949120584.846c0a63.jpg";